import _ from 'lodash'
import fetch from 'isomorphic-fetch'
import { getAPIendpointPrefix } from '../actions/apiHelper'

// disable until analytics are required
const enableLogFile = true

export const ANALYTICS_MIDDLEWARE_KEY = Symbol('Analytics Middleware')

export default store => next => action => {
  const analyticsConfig = action[ANALYTICS_MIDDLEWARE_KEY]
  if (_.isUndefined(analyticsConfig)) {
    return next(action)
  }

  const [methodToCall, parameters] = analyticsConfig

  // log to EFS log file
  if (enableLogFile === true) {
    const activity = store.getState().core.activity
    if (parameters[0].data === undefined) {
      parameters[0].data = {}
    }

    // get uuid
    if (activity && activity.config && activity.config.toolInfo) {
      parameters[0].data.uuid = activity.config.toolInfo.uuid
    } else if (parameters[0] && parameters[0].data && parameters[0].data.uuid) {
      // just use the existing value
    } else {
      // set to none so that the log process will still be successful
      parameters[0].data.uuid = 'none'
    }

    if (parameters[0].data && activity && activity.config && activity.config.file) {
      parameters[0].data.actEndp = activity.config.file + '.txt'
    }

    parameters[0].data.returnUrl = ''
    if (store.getState().routing && store.getState().routing.locationBeforeTransitions &&
      store.getState().routing.locationBeforeTransitions.query &&
      store.getState().routing.locationBeforeTransitions.query.return_url) {
      parameters[0].data.returnUrl = store.getState().routing.locationBeforeTransitions.query.return_url
    }

    logEvent(parameters[0].category, parameters[0].action, parameters[0].data)
  }

  const newAction = { ...action }
  delete newAction[ANALYTICS_MIDDLEWARE_KEY]
  return next(newAction)
}

// local functions

function logEvent (category, action, data) {
  fetch(getAPIendpointPrefix() + 'api/v1/analytics/log_analytics.php', {
    method: 'POST',
    body: JSON.stringify({
      op: 'logAnalyticsEvent',
      action,
      category,
      data
    })
  }).then(res => res.text())
}
